(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('timeBoard', {
                parent: 'app',
                url: '/timeBoard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/time-board/time-board.html',
                        controller: 'TimeBoardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })


        ;

    }
})();
